<template>
    <v-layout row>
        <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
            <v-card>
                <v-card-title>
                    Verify Email
                </v-card-title>
                <v-card-text>
                    You must verify your email address before logging in for the
                    first time. Please check your email and click the verify
                    link to enter the knowledgebase.
                </v-card-text>
            </v-card>

            <v-card class="mt-4">
                <v-card-title>
                    Re-send verification link
                </v-card-title>
                <v-card-text>
                    <form @submit.prevent="sendVerificationEmail" id="form">
                        <v-text-field
                            v-model="email"
                            :disabled="formLoading"
                            :success-messages="successMessages"
                            :error-messages="errorMessages"
                            label="Email"
                            type="email"
                            required
                        />
                    </form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="formLoading"
                        color="primary darken-1"
                        text
                        form="form"
                        type="submit"
                        >Send</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Login',
    data: () => ({
        email: '',
        successMessages: '',
        errorMessages: '',
        formLoading: false,
    }),
    methods: {
        login() {
            this.$auth.loginWithRedirect()
        },

        sendVerificationEmail() {
            this.formLoading = true

            axios
                .post(process.env.VUE_APP_API_ENDPOINT + 'verification-email', {
                    email: this.email,
                })
                .then(({ data }) => {
                    if (data.success) {
                        this.successMessages = data.message;
                        this.email = '';
                    } else {
                        this.errorMessages = data.message;
                    }
                })
                .finally(() => {
                    this.formLoading = false
                })
        },
    },
}
</script>
